import React from 'react';
import { dispactConnect, Action, combineAction } from 'combine-action';
import Kotak from './Kotak'

class Line extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            kotak: 'abcdefgh'.split(''),
        };
    }

    renderKotak() {
        return this.state.kotak.map((hurup, index) => {
            return (
                <Kotak key={index}
                    pos={index + 1}
                    hurup={hurup}
                    number={this.props.number}
                    biji={this.props.formasi[index]}
                />
            );
        })
    }

    render() {
        return (
            <div className="line" data-number={this.props.number}>
                {this.renderKotak()}
            </div>
        );
    }
}

export default dispactConnect((Line), combineAction(Action.HomeAction), ['HomeReducer']);
